import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

export const useStyles = makeStyles(() => createStyles({
  groupWrapper: {
    width: '100%',
    height: '40px',
    borderTop: '2px solid #6C59E6',
    background: '#F9E8FF',
    padding: '10px 16px',
    marginBottom: '16px',
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  nameWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    marginBottom: 'auto',
  },
  icon: {
    color: '#6C59E6',
    height: '20px',
    width: '20px',
  },
  name: {
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '20px',
    color: '#6C59E6',
  },
  body: {
    padding: '0 16px',
  },
  actionsWrapper: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    '& .trash, .drag': {
      color: '#6C59E6',
    },
  },
}));
